import { PartyDto } from '@g2-shared/api-client/generated/onboarding-app';
import { getServerErrorMessage } from '@g2-shared/common';
import { useQuery } from 'react-query';
import { FIND_PARTY_BY_SELF_USER, usePartyApiDefaultConfig } from '../../config';
import { DIContext } from '../../context';

interface useFindPartyBySelfUserInterface {
  party?: PartyDto | null;
  isLoading: boolean;
  errorMessage: string;
}

export const useFindPartyBySelfUser = (disabled?: boolean): useFindPartyBySelfUserInterface => {
  const config = usePartyApiDefaultConfig('useFindPartyBySelfUser');
  const { OnboardingApiClient } = DIContext;

  const { data, isLoading, error } = useQuery(
    [FIND_PARTY_BY_SELF_USER],
    async () => {
      try {
        const response = await OnboardingApiClient.findPartyBySelfUser();
        return response.data.result;
      } catch (e) {
        return null;
      }
    },
    {
      ...config,
      enabled: !disabled,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5000,
    }
  );

  return {
    party: data,
    isLoading,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
  };
};
